import { Stack, styled } from "@mui/material";

export const BestSellersWrapper = styled(Stack)(({ theme }) => {
	return {
		gap: "calc(var(--flex-gap)/3)",
		justifyContent: "space-between",
		padding:
			"calc(var(--basic-padding)/2) calc(var(--basic-padding)/2) calc(var(--basic-padding)/1.5)",
		"& .best-sellers-LHS": {
			gap: "calc(var(--flex-gap)/4)",
		},
		"& .best-sellers-RHS": {
			gap: "calc(var(--flex-gap)/2)",
			flexGrow: 1,
			"& .best-sellers-show-all-button-box": {
				overflow: "hidden",
			},
			"& .best-seller-grid-item": {
				overflow: "hidden",
				"& .best-seller-grid-item-body": {
					justifyContent: "space-between",
					height: "-webkit-fill-available",
					padding: "calc(var(--basic-padding)/4)",
					borderRadius: "12px",
					gap: "calc(var(--flex-gap)/8)",
					border: "1px solid var(--border-faint-primary-color)",
					"& .best-seller-thumbnail-box": {
						cursor: "pointer",
						height: "11.25rem",
						"& img": {
							width: "100%",
							height: "100%",
							objectFit: "cover",
							borderRadius: "10px",
						},
					},
				},
			},
		},
		[theme.breakpoints.up("tablet")]: {
			padding:
				"calc(var(--basic-padding)/2) calc(var(--basic-padding)) calc(var(--basic-padding)/1.5)",
		},
		[theme.breakpoints.up("laptop")]: {
			flexDirection: "row",
			"& .best-sellers-LHS": {
				// gap: "calc(var(--flex-gap)/2)"
			},
			"& .best-sellers-RHS": {
				"& .best-sellers-show-all-button-box": {
					"& button": {
						float: "right",
					},
				},
			},
		},
		[theme.breakpoints.up("xl")]: {
			"& .best-sellers-LHS": {
				// gap: "calc(var(--flex-gap))"
			},
		},
	};
});
